module.exports = __webpack_public_path__ + "static/media/stackIcons.fe86b122.png";